import styled from "styled-components";
import { neutral10, brandlight, neutral7 } from "../../../css/colors";
import { media } from "../../../css/breakpoints";
export const primaryFontFamily = "Roboto-Regular";
export const Container = styled.div `
  position: relative;
  margin: 0 auto;
`;
export const InnerWrapper = styled.div `
  position: fixed;
  display: flex;
  background-color: ${brandlight};
  bottom: 0;
  z-index: 9999;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 518px;
  height: 29%;
  left: 36%;
  min-height: 200px;
  ${media.mobileDown} {
    width: 100%;
    height: 25%;
    left: 0;
  }
`;
export const PopUpTitle = styled.div `
  font-family: ${primaryFontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 0.91;
  text-align: center;
  color: ${neutral10};
  ${media.mobileDown} {
    font-size: 16px;
    line-height: 1.25;
  }
`;
export const PopUpDesc = styled.div `
  font-family: ${primaryFontFamily};
  font-size: 16px;
  line-height: 1.44;
  text-align: center;
  color: ${neutral7};
  padding: 0px 68px;
  margin-top: 12px;
  margin-bottom: 24px;
  ${media.mobileDown} {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.29;
  }
`;
export const IconContainer = styled.div `
  align-items: end;
  display: flex;
  justify-content: flex-end;
  right: 8px;
  position: absolute;
  top: 8px;
  padding-right: 8px;
  cursor: pointer;
`;
export const closeIcon = styled.div `
  width: 20px;
  height: 20px;
  margin-left: 14px;
  cursor: pointer;
`;

